import React from "react";
import Page from "../components/Page";
import I18n from "../I18n";

function Rules() {
	return (
		<Page title={<I18n t="main.route.rules" />}>
			Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id autem blanditiis nulla? Placeat, omnis tempore
			facere quo fuga maiores! Consectetur nostrum rerum qui tempore doloribus repellendus eius ab at temporibus
			quis alias nam recusandae a omnis, ipsam veniam soluta autem quas sequi est voluptates? Animi at dolore
			dolorum eius, quam soluta quis nesciunt vitae, sunt aliquam velit reiciendis voluptate sit? Voluptatibus
			minus, eveniet voluptas soluta sint recusandae autem ipsa sunt quasi consectetur facere blanditiis hic
			quidem dolorem provident vero accusantium, cupiditate voluptatum officiis perferendis iste eaque? Similique
			placeat inventore, delectus animi magnam doloremque molestias distinctio, veniam fuga dignissimos culpa
			saepe. Laboriosam sequi maiores eligendi id! Perferendis porro, architecto at rem commodi maxime debitis
			dolorem eum. Fugit sunt obcaecati minima veniam nostrum temporibus corrupti facilis culpa fuga quis
			accusantium, quae iusto amet asperiores a sed. Debitis minima nam mollitia neque vitae earum ad dolore quia
			provident praesentium officia repudiandae, assumenda reprehenderit, temporibus aspernatur, veniam unde
			deserunt sunt itaque quibusdam dolorem esse. Dignissimos, veniam perspiciatis aspernatur earum magni amet
			alias quas explicabo ex quos distinctio. Autem aperiam dolorum doloremque natus, neque deserunt numquam
			itaque omnis sed sunt perferendis corrupti repellendus, aspernatur illo, ipsum aliquam ex ad. Cumque
			dignissimos odit temporibus nam consectetur consequatur esse omnis nemo eligendi cum quasi adipisci tempore
			eum in, fugit, iusto vero voluptatibus praesentium! Error explicabo nam repellat odit iure quas voluptates
			vitae minima quis harum maiores exercitationem consectetur id, dolores quia officiis tenetur ipsam
			dignissimos? Quidem reprehenderit commodi recusandae eaque officiis rerum maiores quam accusantium nisi.
		</Page>
	);
}

export default Rules;
